module.exports = __webpack_public_path__ + "static/media/logo.82296d6c.png";